import React, { useState, useEffect, useContext } from "react";
import { Switch, Route, NavLink } from "react-router-dom";
import { Badge, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Joi from "joi";
import moment from "moment";
import _ from "lodash";
import Input from "./common/input";
import http from "../services/http";
import auth from "../services/authService";
import UserContext from "../context/userContext";
import Select from "./common/select";
import Checkbox from "./common/checkbox";

const Profile = () => {
  const [access, setAccess] = useState([]);

  useEffect(() => {
    async function getAccess() {
      try {
        const { data } = await http.get(`/data-access`);
        setAccess(data);
      }
      catch {
        //ignore error
      }
    }

    getAccess();
    document.title = "FTR - Profile";
    return () => {
      document.title = "FTR";
    };
  }, []);

  const ProfileView = () => {
    const [user, setUser] = useContext(UserContext);

    const [profile, setProfile] = useState(user);
    // const [errors, setErrors] = useState({});
    const errors = {};

    useEffect(() => {
      const profile = { ...user };
      if (!profile.FIRST_NAME) profile.FIRST_NAME = "";
      if (!profile.LAST_NAME) profile.LAST_NAME = "";
      if (!profile.EMAIL) profile.EMAIL = "";
      setProfile(profile);
    }, [user]);

    function handleChange({ currentTarget: input }) {
      const info = { ...profile };
      info[input.name] = input.value;
      setProfile(info);
    }

    async function handleUpdate(e) {
      e.preventDefault();
      const newProfile = _.pick(profile, ["FIRST_NAME", "LAST_NAME", "EMAIL"]);

      try {
        const { data } = await http.put(`/profile`, newProfile);
        auth.updateToken(data);
        toast.success("Profile Updated");
        setUser({
          ...profile,
          FULL_NAME: `${profile.FIRST_NAME} ${profile.LAST_NAME}`,
        });
      } catch (ex) {
        if (ex.response && ex.response.status < 500) {
          toast.error(ex.response.data);
        }
      }
    }

    const ListItem = ({ label, checked }) => {
      return (
        <li>
          <span className="fa-li">
            {checked ? (
              <i className="fas fa-check text-success"></i>
            ) : (
              <i className="fas fa-times text-danger"></i>
            )}
          </span>
          {label}
        </li>
      );
    };

    const readAccess = profile
      ? access.find((a) => a.ID === profile.READ_ACCESS)
      : "";
    const writeAccess = profile
      ? access.find((a) => a.ID === profile.WRITE_ACCESS)
      : "";

    return (
      <form>
        <h5>{profile && profile.USERNAME}</h5>
        <Input
          name="FIRST_NAME"
          label="First Name"
          error={errors.FIRST_NAME}
          placeholder="First Name"
          value={profile && profile.FIRST_NAME}
          onChange={handleChange}
        />
        <Input
          name="LAST_NAME"
          label="Surname"
          error={errors.LAST_NAME}
          placeholder="Surname"
          value={profile && profile.LAST_NAME}
          onChange={handleChange}
        />
        <Input
          name="EMAIL"
          label="Email"
          error={errors.EMAIL}
          placeholder="Email Address"
          value={profile && profile.EMAIL}
          onChange={handleChange}
        />
        <button className="btn btn-primary" onClick={handleUpdate}>
          Update
        </button>
        <div className="row justify-content-center mt-3">
        <div className="col">
            <ul className="fa-ul list-inline">
              <ListItem label="Bardney" checked={profile && profile.ACCESS_BA} />
            </ul>
          </div>
          <div className="col">
            <ul className="fa-ul list-inline">
              <ListItem label="Bury" checked={profile && profile.ACCESS_BU} />
            </ul>
          </div>
          <div className="col">
            <ul className="fa-ul list-inline">
              <ListItem
                label="Cantley"
                checked={profile && profile.ACCESS_CA} />
            </ul>
          </div>
          <div className="col">
            <ul className="fa-ul list-inline">
              <ListItem
                label="Newark"
                checked={profile && profile.ACCESS_NE} />
            </ul>
          </div>
          <div className="col">
            <ul className="fa-ul list-inline">
              <ListItem
                label="Wissington"
                checked={profile && profile.ACCESS_WI} />
            </ul>
          </div>
          <div className="col">
            <ul className="fa-ul list-inline">
              <ListItem
                label="Central Office"
                checked={profile && profile.ACCESS_CO} />
            </ul>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-4">
            <p className="lead text-center">
              Read Access: {readAccess && readAccess.DESCRIPTION}
            </p>
          </div>
          <div className="col-4">
            <p className="lead text-center">
              Write Access: {writeAccess && writeAccess.DESCRIPTION}
            </p>
          </div>
        </div>
        <div className="row justify-content-center mt-4">
          <div className="col-3">
            <ul className="fa-ul">
              <ListItem
                label="View Data Screens"
                checked={profile && profile.VIEW_DATA_SCREENS} />
              <ListItem
                label="View Dashboards"
                checked={profile && profile.VIEW_DASHBOARDS} />
              <ListItem
                label="View Reports"
                checked={profile && profile.REPORTS} />
              <ListItem
                label="View Grabbers"
                checked={profile && profile.DATA_GRABBER} />
              <ListItem
                label="View Live Data"
                checked={profile && profile.LIVE_DATA} />
              <ListItem
                label="View CCFs"
                checked={profile && profile.VIEW_CCF} />
            </ul>
          </div>
          <div className="col-3">
            <ul className="fa-ul">
              <ListItem
                label="Edit Data Screens"
                checked={profile && profile.MAINTAIN_DATA_SCREENS} />
              <ListItem
                label="Edit Dashboards"
                checked={profile && profile.MAINTAIN_DASHBOARDS} />
              <ListItem
                label="Edit Reports"
                checked={profile && profile.MAINTAIN_REPORTS} />
              <ListItem
                label="Edit Grabbers"
                checked={profile && profile.MAINTAIN_GRABBERS} />
              <ListItem
                label="Edit Parameters"
                checked={profile && profile.PARAMETERS} />
              <ListItem
                label="Edit Historic Data"
                checked={profile && profile.HISTORIC_DATA} />
            </ul>
          </div>
          <div className="col-3">
            <ul className="fa-ul">
              <ListItem
                label="Constants"
                checked={profile && profile.CONSTANTS} />
              <ListItem
                label="Production Comments"
                checked={profile && profile.PRODUCTION_COMMENTS} />
              <ListItem
                label="Operations"
                checked={profile && profile.OPERATIONS} />
              <ListItem
                label="Lookups"
                checked={profile && profile.LOOKUPS} />
              <ListItem
                label="Users"
                checked={profile && profile.USERS} />
              <ListItem
                label="Recalculate"
                checked={profile && profile.RECALCULATE} />
              <ListItem
                label="CCF Settings"
                checked={profile && profile.MAINTAIN_CCF} />
            </ul>
          </div>
        </div>
      </form>
    );
  };

  const PasswordView = () => {
    const [passwords, setPasswords] = useState({
      oldPassword: "",
      newPassword: "",
      newPassword2: "",
    });
    const [errors, setErrors] = useState({});

    const passwordSchema = {
      oldPassword: Joi.string().required().label("Old Password"),
      newPassword: Joi.string().min(14).required().label("New Password"),
      newPassword2: Joi.string().min(14).required().label("Repeated Password"),
    };

    function validate() {
      const options = { abortEarly: false };
      const { error } = Joi.object(passwordSchema).validate(passwords, options);
      if (!error) return null;

      const newErrors = {};
      for (let item of error.details) newErrors[item.path[0]] = item.message;
      return newErrors;
    }

    function handlePassword({ currentTarget: input }) {
      const pass = { ...passwords };
      pass[input.name] = input.value;
      setPasswords(pass);
    }

    async function handlePasswordChange(e) {
      e.preventDefault();

      const newErrors = validate();
      setErrors(newErrors || {});
      if (newErrors) return;

      if (passwords.newPassword !== passwords.newPassword2)
        return toast.error("Passwords don't match");

      try {
        const { data } = await http.patch(`/user/password`, passwords);
        auth.updateToken(data);
        toast.success("Password Updated");
      } catch (ex) {
        console.log(ex);
        if (ex.response && ex.response.status < 500) {
          toast.error(ex.response.data);
        }
      }
    }

    return (
      <form className="row">
        <div className="px-5">
          <p className="lead">
            New password must be at least 14 characters and include 3 of the
            following: lowercase, uppercase, numbers and symbols
          </p>
        </div>
        <div className="col-sm-6 mx-auto">
          <Input
            name="oldPassword"
            label="Current Password"
            placeholder="Password"
            type="password"
            value={passwords.oldPassword}
            onChange={handlePassword}
            error={errors.oldPassword}
          />
          <Input
            name="newPassword"
            label="New Password"
            placeholder="Password"
            type="password"
            value={passwords.newPassword}
            onChange={handlePassword}
            error={errors.newPassword}
          />
          <Input
            name="newPassword2"
            label="Repeat New Password"
            placeholder="Password"
            type="password"
            value={passwords.newPassword2}
            onChange={handlePassword}
            error={errors.newPassword2}
          />
          <button className="btn btn-primary" onClick={handlePasswordChange}>
            Change Password
          </button>
        </div>
      </form>
    );
  };

  const SubscriptionView = () => {
    const [user] = useContext(UserContext);
    const [subscriptions, setSubscriptions] = useState([]);

    const [data, setData] = useState({});
    const [id, setId] = useState();
    const [showModal, setShowModal] = useState(false);

    const subscriptionTypes = [
      { id: 1, name: "On Value Entered" },
      { id: 2, name: "Data Outside Check Limits" },
      { id: 3, name: "Data Outside Absolute Limits" },
    ];

    useEffect(() => {
      async function getSubscriptions() {
        try {
          const { data } = await http.get("/parameter-subscribe");
          setSubscriptions(data);
        }
        catch {
          //ignore error
        }
      }

      if (user) {
        getSubscriptions();
      }
    }, [user]);

    const handleRemove = async (subscription) => {
      const oldSubscriptions = [...subscriptions];
      setSubscriptions(
        subscriptions.filter((sub) => sub.ID !== subscription.ID)
      );
      try {
        await http.delete(`/parameter-subscribe/${subscription.ID}`);
        toast.success("Subscription Removed");
      } catch (err) {
        setSubscriptions(oldSubscriptions);
      }
    };

    const handleShowModal = (subscription) => {
      const data = {
        type: subscription.SUBSCRIPTION_TYPE,
        email: subscription.EMAIL,
        push: subscription.PUSH_NOTIFICATION,
      };
      setData(data);
      setId(subscription.ID);
      setShowModal(true);
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      const oldSubscriptions = [...subscriptions];
      const newSubscriptions = [...subscriptions];
      try {
        const { data: update } = await http.put(
          `/parameter-subscribe/${id}`,
          data
        );
        const index = newSubscriptions.findIndex((s) => s.ID === id);
        newSubscriptions[index] = update;
        setSubscriptions(newSubscriptions);
        handleClose();
      } catch (error) {
        setSubscriptions(oldSubscriptions);
        if (error.response && error.response.status < 500) {
          toast.error(error.response.data);
        }
      }
    };

    const handleChange = ({ currentTarget: input }) => {
      const newData = { ...data };
      const value = input.type === "checkbox" ? input.checked : input.value;
      newData[input.name] = value;
      setData(newData);
    };

    const handleClose = () => {
      setData({});
      setId();
      setShowModal(false);
    };

    if (subscriptions.length === 0)
      return <h5 className="text-center text-muted mt-4">No Subscriptions</h5>;
    return (
      <>
        <table className="table">
          <thead>
            <tr>
              <th>Parameter</th>
              <th>Site</th>
              <th>Subscription</th>
              <th>Email</th>
              <th>Push</th>
              <th>Last Updated</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {subscriptions.map((sub) => (
              <tr key={sub.ID}>
                <td>
                  <button
                    className="btn btn-link p-0"
                    onClick={() => handleShowModal(sub)}
                  >
                    {sub.PARM_CODE}
                  </button>
                </td>
                <td>{sub.SITE_NAME}</td>
                <td>{sub.SUBSCRIPTION}</td>
                <td>
                  {sub.EMAIL ? (
                    <Badge variant="success">True</Badge>
                  ) : (
                    <Badge variant="warning">False</Badge>
                  )}
                </td>
                <td>
                  {sub.PUSH_NOTIFICATION ? (
                    <Badge variant="success">True</Badge>
                  ) : (
                    <Badge variant="warning">False</Badge>
                  )}
                </td>
                <td>{moment(sub.LAST_UPDATED_DTS).fromNow()}</td>
                <td>
                  <button
                    onClick={() => handleRemove(sub)}
                    className="btn btn-danger btn-sm"
                  >
                    <i className="fas fa-trash text-white"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header closeButton className="bg-success text-white">Update Subscription</Modal.Header>
          <form onSubmit={handleSubmit}>
            <Modal.Body>
              <Select
                name="type"
                placeholder="Select Type"
                label="Subscription Type"
                value={data.type}
                options={subscriptionTypes}
                onChange={handleChange}
              />
              <Checkbox
                name="email"
                checked={data.email}
                onChange={handleChange}
                label="Email"
              />
              <Checkbox
                name="push"
                checked={data.push}
                onChange={handleChange}
                label="Push Notifications"
              />
            </Modal.Body>
            <Modal.Footer>
              <button onClick={handleSubmit} className="btn btn-primary">
                Update
              </button>
            </Modal.Footer>
          </form>
        </Modal>
      </>
    );
  };

  const FavouriteView = () => {
    const [favourites, setFavourites] = useState([]);

    useEffect(() => {
      const getFavourites = async () => {
        const { data } = await http.get("data-screen-favourites/");
        setFavourites(data);
      };
      getFavourites();
    }, []);

    const handleDelete = async (favourite) => {
      const oldFavourites = [...favourites];
      setFavourites((f) => f.filter((f) => f.ID !== favourite.ID));
      try {
        await http.delete(`data-screen-favourites/${favourite.ID}`);
        toast.success("Favourite Removed");
      } catch (error) {
        setFavourites(oldFavourites);
        toast.error(error.response.data);
      }
    };

    return (
      <>
        <table className="table">
          <thead>
            <tr>
              <th>Data Screen Name</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {favourites.map((f) => (
              <tr key={f.id}>
                <td>{f.DESCRIPTION}</td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(f)}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  };

  return (
    <div className="col mt-4 profile">
      <div className="container">
        <div className="row">
          <div className="col-2 mt-5">
            <ul className="list-group list-group-flush">
              <NavLink exact to="/profile" className="app-help-list-item mb-1">
                Profile
              </NavLink>
              <NavLink
                to="/profile/password"
                className="app-help-list-item mb-1"
              >
                Change Password
              </NavLink>
              <NavLink
                to="/profile/subscriptions"
                className="app-help-list-item mb-1"
              >
                My Subscriptions
              </NavLink>
              <NavLink
                to="/profile/favourites"
                className="app-help-list-item mb-1"
              >
                My Favourites
              </NavLink>
            </ul>
          </div>
          <div className="col-10">
            <Switch>
              <Route path="/profile/favourites">
                <FavouriteView />
              </Route>
              <Route path="/profile/subscriptions">
                <SubscriptionView />
              </Route>
              <Route path="/profile/password">
                <PasswordView />
              </Route>
              <Route path="/profile">
                <ProfileView />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
